import { render } from "./MartinThierry.vue?vue&type=template&id=4b225c77&scoped=true&ts=true"
import script from "./MartinThierry.vue?vue&type=script&lang=ts"
export * from "./MartinThierry.vue?vue&type=script&lang=ts"

import "./MartinThierry.vue?vue&type=style&index=0&id=4b225c77&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b225c77"]])

export default __exports__